export function renderBulletListBlock({ content, items = [] }) {
  const filtered = Array.isArray(items)
    ? items
        .map(i => {
          if (typeof i === "string") return i;
          return i?.text;
        })
        .filter(text => typeof text === "string" && text.trim() !== "")
    : [];

  if (filtered.length > 0) {
    content.push({
      ul: filtered,
      style: "list",
      alignment: "left",
    });
  }
}